// extracted by mini-css-extract-plugin
module.exports = {"agents":"EmptyHero_agents__06Htq","home":"EmptyHero_home__iZxJK"};